import styled from 'styled-components'

export const FieldRowStyled = styled.div`
  min-height: ${(props) => props.theme.typography.pxToRem(86)};
`
